import Component from '../classes/Component';
import { $dom } from '../helpers/dom';

const { get, getAll } = $dom;

const uploadFileSelector = '.js-upload-file';
const uploadFileListSelector = '.js-upload-file-list';
const uploadFileListDeleteSelector = '.js-upload-file-list-delete';
const uploadFileListDeleteAllSelector = '.js-upload-file-list-delete-all';

export function fileLoad() {
  return new Component({
    name: 'fileLoad',
    requiredTargets: uploadFileSelector,
    onCreate() { },
    onInit() {

      function declensionNum(num, words) {
        return words[(num % 100 > 4 && num % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(num % 10 < 5) ? num % 10 : 5]];
      }

      const fInputs = document.querySelectorAll('.btcd-f-input>div>input')

      function getFileSize(size) {
        let _size = size
        let unt = ['Bytes', 'KB', 'MB', 'GB'],
          i = 0; while (_size > 900) { _size /= 1024; i++; }
        return (Math.round(_size * 100) / 100) + ' ' + unt[i];
      }

      function delItem(el) {
        fileList = { files: [] }
        let fInp = el.parentNode.parentNode.parentNode.querySelector('input[type="file"]')
        for (let i = 0; i < fInp.files.length; i++) {
          fileList.files.push(fInp.files[i])
        }
        fileList.files.splice(el.getAttribute('data-index'), 1)

        fInp.files = createFileList(...fileList.files)
        // if (fInp.files.length > 0) {
        //   el.parentNode.parentNode.parentNode.querySelector('.btcd-f-title').innerHTML = `${fInp.files.length} File Selected`
        // } else {
        //   el.parentNode.parentNode.parentNode.querySelector('.btcd-f-title').innerHTML = 'No File Chosen'
        // }

        let filesSize = null;

        for (let i = 0; i < fileList.files.length; i++) {
          filesSize += fileList.files[i].size;
        }

        get('.js-upload-file-size', el.parentNode.parentNode.parentNode).innerHTML = `${fileList.files.length} ${declensionNum(fileList.files.length, ['файл', 'файла', 'файлов'])}. (${getFileSize(filesSize)}) <span class="js-upload-file-list-delete-all">удалить все</span>`;

        console.log(fileList.files.length);

        if (fileList.files.length < 1) {
          get('.js-upload-file-size', el.parentNode.parentNode.parentNode).innerHTML = '';
        }

        el.parentNode.remove()
      }

      function fade(element) {
        let op = 1;  // initial opacity
        let timer = setInterval(function () {
          if (op <= 0.1) {
            clearInterval(timer);
            element.style.display = 'none';
          }
          element.style.opacity = op;
          element.style.filter = 'alpha(opacity=' + op * 100 + ")";
          op -= op * 0.1;
        }, 50);
      }

      function unfade(element) {
        let op = 0.01;  // initial opacity
        element.style.opacity = op;
        element.style.display = 'flex';
        let timer = setInterval(function () {
          if (op >= 1) {
            clearInterval(timer);
          }
          element.style.opacity = op;
          element.style.filter = 'alpha(opacity=' + op * 100 + ")";
          op += op * 0.1;
        }, 13);
      }

      function get_browser() {
        let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
          return { name: 'IE', version: (tem[1] || '') };
        }
        if (M[1] === 'Chrome') {
          tem = ua.match(/\bOPR|Edge\/(\d+)/)
          if (tem != null) { return { name: 'Opera', version: tem[1] }; }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
        return {
          name: M[0],
          version: M[1]
        };
      }

      for (let inp of fInputs) {
        // inp.parentNode.querySelector('.btcd-inpBtn>img').src = 'data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDY0IDY0IiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGlkPSJDbGlwIj48cGF0aCBkPSJtMTIuMDggNTcuNzQ5YTkgOSAwIDAgMCAxMi43MjggMGwzMS4xMTItMzEuMTEzYTEzIDEzIDAgMSAwIC0xOC4zODQtMTguMzg1bC0yMC41MDcgMjAuNTA2IDEuNDE1IDEuNDE1IDIwLjUwNi0yMC41MDZhMTEgMTEgMCAxIDEgMTUuNTU2IDE1LjU1NmwtMzEuMTEyIDMxLjExMmE3IDcgMCAwIDEgLTkuOS05LjlsMjYuODctMjYuODdhMyAzIDAgMCAxIDQuMjQyIDQuMjQzbC0xNi4yNjMgMTYuMjY0IDEuNDE0IDEuNDE0IDE2LjI2NC0xNi4yNjNhNSA1IDAgMCAwIC03LjA3MS03LjA3MWwtMjYuODcgMjYuODdhOSA5IDAgMCAwIDAgMTIuNzI4eiIvPjwvZz48L3N2Zz4='
        inp.addEventListener('mousedown', function (e) { setPrevData(e) })
        inp.addEventListener('change', function (e) { handleFile(e) })
      }

      let fileList = { files: [] }
      let fName = null
      let mxSiz = 25000

      function setPrevData(e) {
        if (e.target.hasAttribute('multiple') && fName !== e.target.name) {
          // console.log('multiple')
          fName = e.target.name
          fileList = fileList = { files: [] }
          if (e.target.files.length > 0) {
            for (let i = 0; i < e.target.files.length; i += 1) {
              // console.log(e.target.files[i])
              fileList.files.push(e.target.files[i])
            }
          }
        }
      }

      function handleFile(e) {

        // let size = null;

        let err = []
        const fLen = e.target.files.length;
        mxSiz = e.target.parentNode.querySelector('.f-max')
        mxSiz = mxSiz != null && (Number(mxSiz.innerHTML.replace(/\D/g, '')) * Math.pow(1024, 2))
        mxSiz = 26214400;
        if (e.target.hasAttribute('multiple')) {
          for (let i = 0; i < fLen; i += 1) {
            fileList.files.push(e.target.files[i])
          }
        } else {
          fileList.files.push(e.target.files[0])
        }

        //type validate
        if (e.target.hasAttribute('accept')) {
          let tmpf = []
          let type = new RegExp(e.target.getAttribute('accept').split(",").join("$|") + '$', 'gi')
          for (let i = 0; i < fileList.files.length; i += 1) {
            if (fileList.files[i].name.match(type)) {
              tmpf.push(fileList.files[i])
            } else {
              err.push('Wrong File Type Selected')
            }
          }
          fileList.files = tmpf
        }

        console.log(fileList.files);
        console.log(fileList.files[0].size);

        /*if (fileList.files[0].size >= 25000000) {
          console.log('the size are more than 25 mb');

          get('.js-upload-file-size', e.target.parentNode.parentNode).innerHTML = `Размер не должен превышать 25МБ`;

          const fileListArr = Array.from(fileList.files);
          fileListArr.splice(fileList.files.length - 1, 1);

          fileList.files = fileListArr;

          // console.log(fileList.files);

          return;
        }*/



        if (fileList.files.length > 1) {
          // console.log(fileList.files[fileList.files.length - 1]);

          // fileList.files[fileList.files.length - 1] = null;

          const fileListArr = Array.from(fileList.files);
          fileListArr.splice(fileList.files.length - 1, 1);

          fileList.files = fileListArr;
        }

        // console.log(fileList.files);

        // size validate
        if (mxSiz > 0) {
          let tmpf = []

          for (let i = 0; i < fileList.files.length; i += 1) {
            if (fileList.files[i].size < mxSiz) {
              tmpf.push(fileList.files[i])
              //mxSiz -= fileList.files[i].size
            } else {
              console.log('rejected', i, fileList.files[i].size,mxSiz)
              err.push('Размер не должен превышать 25МБ')
              fileList = { files: [] }
              console.log('clear');
              for (let i = 0; i < err.length; i += 1) {
                e.target.parentNode.parentNode.querySelector('.btcd-files').insertAdjacentHTML('afterbegin', `
                  <div style="background: #fff2f2;color: darkred;display:none" class="btcd-f-err">
                      <img src="data:image/svg+xml;base64,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" alt="img">
                      <span>${err[i]}</span>
                  </div>`)
              }
              const errNods = e.target.parentNode.parentNode.querySelectorAll('.btcd-files>.btcd-f-err')
              for (let i = 0; i < errNods.length; i += 1) {
                unfade(errNods[i])
                setTimeout(() => { fade(errNods[i]) }, 3000);
                setTimeout(() => { errNods[i].remove() }, 4000);
              }
              err = []

              return;
            }
          }
          fileList.files = tmpf
        }

        if (e.target.hasAttribute('multiple')) {
          e.target.files = createFileList(...fileList.files)
        } else {
          console.log('fileList.files.length', fileList.files.length);
          if (fileList.files.length)
            e.target.files = createFileList(fileList.files[fileList.files.length - 1])
          fileList = { files: [] }
        }

        // set File list view
        if (e.target.files.length > 0) {
          // e.target.parentNode.querySelector('.btcd-f-title').innerHTML = e.target.files.length + ' File Selected'
          e.target.parentNode.parentNode.querySelector('.btcd-files').innerHTML = ''
          for (let i = 0; i < e.target.files.length; i += 1) {
            let img = null
            if (e.target.files[i].type.match(/image-*/)) {
              img = window.URL.createObjectURL(e.target.files[i])
            }
            else {

              // console.log('else thrown');
            }
            e.target.parentNode.parentNode.querySelector('.btcd-files').insertAdjacentHTML('beforeend', `<div class="btcd-files-item">
                    
                    <span title="${e.target.files[i].name}">${e.target.files[i].name}</span>
                    <button type="button" class="btcd-files-item-button js-upload-file-list-delete" data-index="${i}" title="Remove This File">
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 6L18 18" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                </div>`)
            // e.target.parentNode.parentNode.querySelector('.btcd-files').insertAdjacentHTML('beforeend', `<div class="btcd-files-item">

            //         <div>
            //             <span title="${e.target.files[i].name}">${e.target.files[i].name}</span>
            //             <br/>
            //             <small>${getFileSize(e.target.files[i].size)}</small>
            //         </div>
            //         <button type="button" class="btcd-files-item-button js-upload-file-list-delete" data-index="${i}" title="Remove This File">
            //           <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            //             <path d="M18 6L6 18" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            //             <path d="M6 6L18 18" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            //           </svg>
            //         </button>
            //     </div>`)

          }

          let filesSize = null;

          for (let i = 0; i < e.target.files.length; i++) {
            filesSize += e.target.files[i].size;
          }

          // console.log(filesSize);

          declensionNum(e.target.files.length, ['файл', 'файла', 'файлов'])

          // e.target.files.forEach(file => {
          //   console.log(file);
          // })

          // console.log(get('.js-upload-file-size', e.target.parentNode.parentNode));

          if (fileList.files.length == 0) {
            get('.js-upload-file-size', e.target.parentNode.parentNode).innerHTML = `(${getFileSize(filesSize)}) <span class="js-upload-file-list-delete-all">удалить все</span>`;
          } else {
            get('.js-upload-file-size', e.target.parentNode.parentNode).innerHTML = `${fileList.files.length} ${declensionNum(e.target.files.length, ['файл', 'файла', 'файлов'])}. (${getFileSize(filesSize)}) <span class="js-upload-file-list-delete-all">удалить все</span>`;
          }

          // get('.js-upload-file-size', e.target.parentNode.parentNode).innerHTML = `${fileList.files.length} ${declensionNum(e.target.files.length, ['файл', 'файла', 'файлов'])}. (${getFileSize(filesSize)}) <span class="js-upload-file-list-delete-all">удалить все</span>`;
        }

        // set eror
        if (err.length > 0) {
          // for (let i = 0; i < err.length; i += 1) {
          //   e.target.parentNode.parentNode.querySelector('.btcd-files').insertAdjacentHTML('afterbegin', `
          //   <div style="background: #fff2f2;color: darkred;display:none" class="btcd-f-err">
          //       <img src="data:image/svg+xml;base64,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" alt="img">
          //       <span>${err[i]}</span>
          //   </div>`)
          // }
          // const errNods = e.target.parentNode.parentNode.querySelectorAll('.btcd-files>.btcd-f-err')
          // for (let i = 0; i < errNods.length; i += 1) {
          //   unfade(errNods[i])
          //   setTimeout(() => { fade(errNods[i]) }, 30000);
          //   setTimeout(() => { errNods[i].remove() }, 40000);
          // }
          // err = []
        }
      }

      document.querySelectorAll(uploadFileListSelector).forEach(element => {
        element.addEventListener('click', event => {

          if (event.target.closest(uploadFileListDeleteSelector)) {
            const target = event.target.closest(uploadFileListDeleteSelector);

            const checkbox = get('input[type="checkbox"]', target.parentNode.parentNode.parentNode);

            checkbox.checked = true;

            delItem(target)
          }

        })
      })

      document.querySelectorAll(uploadFileSelector).forEach(element => {
        element.addEventListener('click', event => {

          if (event.target.closest(uploadFileListDeleteAllSelector)) {
            const target = event.target.closest(uploadFileListDeleteAllSelector)

            fileList = { files: [] }
            let fInp = get('input[type="file"]', target.parentNode.parentNode);

            for (let i = 0; i < fInp.files.length; i++) {
              fileList.files.push(fInp.files[i])
            }

            fileList.files.splice(0, 5)

            fInp.files = createFileList(...fileList.files)

            get(uploadFileListSelector, target.parentNode.parentNode).innerHTML = '';

            get('.js-upload-file-size', target.parentNode.parentNode).innerHTML = '';
          }

        })
      })
    },
    onDestroy() { }
  })
}